import { render, staticRenderFns } from "./DefinitionBrands.vue?vue&type=template&id=5db77162&"
import script from "./DefinitionBrands.vue?vue&type=script&lang=js&"
export * from "./DefinitionBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports